import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=77d0fcc3&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=77d0fcc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d0fcc3",
  null
  
)

export default component.exports